var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import '../icon-button/icon-button.js';
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let SgdfCircleButton = class SgdfCircleButton extends LitElement {
    render() {
        return html `
            <div class="circle-btn">
                <sgdf-icon-button
                    .library=${this.library}
                    .name=${this.name}
                    style="--icon-color: white;"
                ></sgdf-icon-button>
            </div>
        `;
    }
};
SgdfCircleButton.styles = css `
        .circle-btn {
            height: var(--circle-button-size, 1.75em);
            display: flex;
            align-items: center;
            width: var(--circle-button-size, 1.75em);
            font-size: var(--circle-button-size, 1.75em);
            border-radius: 50%;
            background-color: var(--sgdf-color-default);
            color: white;
            cursor: pointer;
            justify-content: center;
        }
    `;
__decorate([
    property()
], SgdfCircleButton.prototype, "name", void 0);
__decorate([
    property()
], SgdfCircleButton.prototype, "library", void 0);
SgdfCircleButton = __decorate([
    customElement('sgdf-circle-button')
], SgdfCircleButton);
export { SgdfCircleButton };
//# sourceMappingURL=sgdf-circle-button.js.map